/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.


  document.addEventListener('theme:variant:change', function(event) {
    // You might use something like this to write a pre-order feature or a
    // custom swatch feature.
    var variant = event.detail.variant;
    var container = event.target;
    if (variant) {
      console.log('Container ———————— ↓');
      console.log(container);
      console.log('Variant —————————— ↓');
      console.log(variant);
      // ... update some element on the page
    }
  });

  document.addEventListener('theme:cart:change', function(event) {
    var cart = event.detail.cart;
    if (cart) {
      console.log('Cart ———————————— ↓');
      console.log(cart);
      // ... update an app or a custom shipping caluclator
    }
  });
  // Fired when page loads to update header values
  document.addEventListener('theme:cart:init', (e) => {
    console.log('theme:cart:init');
    console.log(e);
  });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  document.addEventListener('theme:scroll', e => { console.log(e); });
  document.addEventListener('theme:scroll:up', e => { console.log(e); });
  document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // Debounced resize listener to bundle changes that trigger document reflow
  document.addEventListener('theme:resize', e => { console.log(e); });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the 
  // scroll locking code knows what element should maintain scoll. 
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
})();


// discount page text:
(function () {

    /**
     * Get translations from data attributes or global object
     */
    function getTranslations() {
        const output = document.getElementById("total-offer-price");

        if (output && output.dataset.totalText) {
            return {
                totalValue: output.dataset.totalText,
                youPayOnly: output.dataset.youPayText || "du betalar endast"
            };
        }

        if (window.shopifyTranslations) {
            return {
                totalValue: window.shopifyTranslations.totalValue || "Totalt värde",
                youPayOnly: window.shopifyTranslations.youPayOnly || "du betalar endast"
            };
        }

        return {
            totalValue: "Totalt värde",
            youPayOnly: "du betalar endast"
        };
    }

    /**
     * Parse price from any currency format
     * Supports:
     * 295,00 kr
     * kr295.00
     * kr.295.00
     * 295 kr
     * $295.00
     */
    function parsePrice(priceText) {

        if (!priceText) return NaN;

        priceText = priceText.trim();

        // Find the first number in the string
        const match = priceText.match(/(\d+(?:[.,]\d+)?)/);

        if (!match) return NaN;

        return parseFloat(match[1].replace(",", "."));
    }

    /**
     * Main function
     */
    function updateOfferText() {

        const output = document.getElementById("total-offer-price");
        const kiteWidget = document.querySelector(".gfgProductPageWrapperV2");
        const productPriceElement = document.querySelector("[data-product-price]");
        const freePriceElement = document.querySelector(".gfgProductPageWrapperV2 .gfgFGv2-price-strike");

        if (!output || !kiteWidget || !productPriceElement || !freePriceElement) {
            return false;
        }

        const productPriceText = productPriceElement.textContent.trim();
        const freePriceText = freePriceElement.textContent.trim();

        const productPrice = parsePrice(productPriceText);
        const freePrice = parsePrice(freePriceText);

        if (isNaN(productPrice) || isNaN(freePrice)) {
            return false;
        }

        // Get currency (kr, $, €, £...)
        const currency = productPriceText.replace(/[\d\s.,]/g, "");

        const total = Math.round(productPrice + freePrice);

        const translations = getTranslations();

        output.innerHTML =
            translations.totalValue +
            ": <strong>" +
            total +
            " " +
            currency +
            "</strong> – " +
            translations.youPayOnly +
            " <strong>" +
            Math.round(productPrice) +
            " " +
            currency +
            "</strong>.";

        output.style.display = "inline-block";
        output.style.marginLeft = "12px";

        return true;
    }

    let attempts = 0;
    const maxAttempts = 20;

    const interval = setInterval(function () {

        attempts++;

        if (updateOfferText() || attempts >= maxAttempts) {
            clearInterval(interval);

            if (attempts >= maxAttempts && !updateOfferText()) {
                console.warn("Total offer price: Failed to update.");
            }
        }

    }, 500);

})();